import "./styles/base.css";
import { initSentry } from "./sentry";
import "./index-app";

initSentry();
document.getElementById("root")?.replaceChildren(document.createElement("ehr-app"));
